<template>
    <div>
      <loadingcomp
        v-bind:mesaj="loadingmesaj"
        v-model="loadingvmodel"
      ></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
  
      <v-dialog
        persistent
        max-width="700px"
        v-model="dialog"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">Firma Kopyala</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-select
                        :items="this.credentials.MuhasebeSirketler"
                        :item-text="item => item.CompanyShortName +' - '+ '(Firma No: ' +  item.CompanyID + ')'"
                        item-value="CompanyID"
                        label="Eski Muhasebe Firması"
                        v-model="firmaKopyalaRequest.OldCompanyID"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-select> 
                </v-flex>
                
              </v-layout>
              <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                  <v-text-field
                  type="number"
      min="0"
                        label="Yeni Muhasebe Firma No"
                        v-model="firmaKopyalaRequest.NewCompanyID"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-text-field> 
                </v-flex>
              </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-form ref="fisNumarasiDegistir">
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <tarihcomp
                          etiket="Dönem Başlangıç (Yeni Oluşacak Firma)"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="firmaKopyalaRequest.PeriodStartDate"
                          :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        >
                        </tarihcomp>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <tarihcomp
                          etiket="Dönem Bitiş (Yeni Oluşacak Firma)"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="firmaKopyalaRequest.PeriodEndDate"
                          :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        >
                        </tarihcomp>
                      </v-flex>
                    </v-layout>
                  
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click.native="agree">
              {{ $t("Copy") }}
            </v-btn>
            <v-btn color="grey" text @click.native="cancel">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-dialog persistent max-width="700px" v-model="controlDialog">
        <v-card>
          <v-card-title class="error">
            <span class="headline white--text">Uyarı</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <blockquote>
                  Firma Kopyalama İşlemi Yapılacaktır ?
                </blockquote>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click.native="makeChange()">
              {{ $t("Copy") }}
            </v-btn>
            <v-btn color="grey" text @click.native="controlDialog = false">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import tarihcomp from "@/components/app/customcomp/tarihim";
  import auth from "../../../../../api/auth";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  
  export default {
    data() {
      return {
        credentials: JSON.parse(window.localStorage.getItem("credentials")),
        controlDialog: false,
        dialog: false,
        loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: "Firma Kopyala",
        tumSirketler: false,
        firmaKopyalaRequest: {
          PeriodStartDate: null,
          PeriodEndDate: null,
          OldCompanyID :null,
          NewCompanyID :null,
          UserID:0
        },
      };
    },
    components: {
      tarihcomp,
      loadingcomp,
      snackbarcomp,
    },
    methods: {
      makeChange() {
        this.loadingvmodel = true
        
         this.firmaKopyalaRequest.UserID=this.credentials.UserID;
          var Params = this.firmaKopyalaRequest
          this.$http.post(auth.API_URL + 'api/AccountingParameters/FirmCopy', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
  
            console.log(response);
  
            this.loadingvmodel = false
            this.text1 =  response.body.ResponseMessage;
            this.snackbar =true;
  
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Hata-' + response.body.ResponseMessage;
              this.snackbar =true;
              this.loadingvmodel = false
            } else {
              this.text1 = 'Service- FirmCopy';
              this.snackbar =true;
              this.loadingvmodel = false
            }
          })
        
         
          this.controlDialog = false;
          this.dialog=false;
      },
      open() {
        this.dialog = true;
      },
      agree() {
        this.controlDialog = true;
      },
      cancel() {
        this.dialog = false;
      },
    },
  };
  </script>
  
  <style>
  </style>
  